import React from 'react';

import type { IconProps } from './icon-types';

const MinimizeIcon = ({ size, fill, svgStyle }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 1"
    aria-hidden="true"
    stroke={fill}
    style={{ margin: '0 auto', ...svgStyle, width: size, height: size }}
  >
    <rect strokeWidth="1.5" y="1" width="20" height="1" fill={fill}></rect>
  </svg>
);

export default MinimizeIcon;
